<template>
  <div class="section-main__warp monitor-page">
    <video-tree v-show="showTree" />
    <div
      style="left: 332px"
      v-show="showTree"
      title="收起"
      class="map-blur-panel__expand-button left iconfont-lunan icon-lunan-shousuocaidan switch"
      @click="showTree = !showTree"
    ></div>
    <div
      title="展开"
      style="left: -4px"
      v-show="!showTree"
      class="map-blur-panel__expand-button right iconfont-lunan icon-lunan-shousuocaidan-copy"
      @click="showTree = !showTree"
    ></div>
    <player-box @handleMultiOpenVideoPanel="handleMultiOpenVideoPanel" />
    <!--录像分段回放 -->
    <appPanel
      :width="850"
      class="app-panel"
      style="z-index: 3"
      :isExpand="showMultiVideoPanel"
      isScreen
      @cancel="handleMultiCloseVideoPanel"
      title="分段回放"
    >
      <multiPlayerBox ref="multiPlayer" playBoxClass="multiPlayerBack" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleMultiCloseVideoPanel" type="info"> 关闭 </el-button>
      </span>
    </appPanel>
  </div>
</template>

<script>
import { Dates } from "$utils";
import appPanel from "@src/components/business/app-panel/index.vue";
import multiPlayerBox from "@src/modules/gatewayManager/components/player-box.vue";
import videoTree from "../components/video-tree";
import playerBox from "../components/player-box";
export default {
  components: {
    videoTree,
    playerBox,
    appPanel,
    multiPlayerBox,
  },
  props: {},
  data() {
    return {
      showTree: true,
      showMultiVideoPanel: false,
    };
  },
  mounted() {},
  methods: {
    // 关闭录像分段播放
    handleMultiCloseVideoPanel() {
      this.showMultiVideoPanel = false;
      this.$refs.multiPlayer.handleStopAllVideo();
    },
    handleMultiOpenVideoPanel(multiForm) {
      this.showMultiVideoPanel = true;
      let timeDistance =
        (multiForm.time[1].getTime() - multiForm.time[0].getTime()) / multiForm.num;
      for (let i = 1; i <= multiForm.num; i++) {
        let obj = {
          thirdCameraId: multiForm.thirdCameraId,
          name: multiForm.name,
          startTime: new Date(
            Dates.dayjs(multiForm.time[0].getTime() + timeDistance * (i - 1)).format(
              "YYYY-MM-DD HH:mm:ss"
            )
          ),
          endTime: new Date(
            Dates.dayjs(multiForm.time[0].getTime() + timeDistance * i).format(
              "YYYY-MM-DD HH:mm:ss"
            )
          ),
        };
        this.$refs.multiPlayer.handlePlayVideo(obj, i);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.monitor-page {
  height: 100%;
}
</style>
